'use client';

import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import useConfig from '@hooks/useConfig';

const FaqComponent = () => {
  const searchParams = useSearchParams();
  const [iframeUrl, setIframeUrl] = useState('');
  const [isMounted, setIsMounted] = useState(false);
  const { config } = useConfig();
  const oldHeight = useRef(0);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    const imboxUrl = searchParams?.get('imboxUrl');
    if (imboxUrl) {
      setIframeUrl(imboxUrl);
    }
  }, [searchParams]);

  useEffect(() => {
    if (isMounted && window?.iFrameResize) {
      window.iFrameResize(
        {
          onResized: function (data: { height: number }) {
            if (data.height > 0) {
              // Check if height changed by more than 20%
              if (Math.abs(data.height - oldHeight.current) / oldHeight.current > 0.2) {
                // If so, scroll to the top of the page
                window.scrollTo(window.scrollX, 0);
              }
            }

            oldHeight.current = data.height;
          },
        },
        '#imboxHelpcenter'
      );
    }
  }, [isMounted]);

  return (
    <>
      {config?.IMBOX_URL && (
        <iframe
          src={config.IMBOX_URL + iframeUrl}
          title="Willys faq"
          id="imboxHelpcenter"
          style={{ width: '1px', minWidth: '100%', border: 'none', height: '100vh' }}
        ></iframe>
      )}
    </>
  );
};

export default FaqComponent;
